/**
 * True when lat/lng look like a real map focus (Monitor / No-fly queries use 0,0 as "unset").
 * Without this, radar rings render off-screen and live queries can wipe vehicles with empty results.
 */
export function isLikelyUserMapCenter(c) {
    if (c == null) {
        return false;
    }
    const { lat, lng } = c;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return false;
    }
    if (lat === 0 && lng === 0) {
        return false;
    }
    return true;
}
/** Prefer real map center; otherwise selected vehicle, then any vehicle with coords or last path point. */
export function pickRadarCenter(mapCenter, vehiclePaths, selectedVehicleId) {
    if (isLikelyUserMapCenter(mapCenter)) {
        return mapCenter;
    }
    if (!vehiclePaths?.length) {
        return undefined;
    }
    const selected = selectedVehicleId && vehiclePaths.find((v) => v.vehicle?.id === selectedVehicleId);
    const v = (selected ?? vehiclePaths[0]);
    if (v.coords) {
        return v.coords;
    }
    const last = v.path?.at(-1);
    if (last) {
        return { lat: last.lat, lng: last.lng };
    }
    return undefined;
}
